import {
  yesNoBadgeColorClasses,
  yesNoBadgeShapeClasses,
  yesNoBadgeWarningClasses,
} from "@/metrics/metric-display"

import type { RunMetricOutput } from "@/types/RunMetricOutput"

import { NumericalMetricRecord } from "../base/NumericalMetricRecord"
import { WithAudioGateMixin } from "../mixins/WithAudioGateMixin"

export class AudioFrequencyMetricRecord extends WithAudioGateMixin(
  NumericalMetricRecord,
) {
  overviewSize = "medium" as const
  unit = "%"
  aggregate_units = "%"

  /** Badge color by naturalness band: >40 natural, 30-40 acceptable, 20-30 slightly robotic, <20 robotic. */
  private _getQualityBadgeClass(value: number): string {
    if (value > 40) {
      return yesNoBadgeColorClasses.success
    }
    if (value >= 30) {
      return yesNoBadgeColorClasses.default
    }
    if (value >= 20) {
      return yesNoBadgeWarningClasses
    }
    return yesNoBadgeColorClasses.danger
  }

  getSingleMetricOutputNode(mo: RunMetricOutput): React.ReactNode | null {
    if (mo.float_value == null || !Number.isFinite(mo.float_value)) {
      return null
    }
    const badgeClass = this._getQualityBadgeClass(mo.float_value)
    return (
      <span className={`${yesNoBadgeShapeClasses} ${badgeClass}`}>
        {mo.float_value.toFixed(2)}
        {this.unit}
      </span>
    )
  }

  _renderSimulationCard(mo: RunMetricOutput): React.ReactNode {
    return this.getSingleMetricOutputNode(mo)
  }

  _renderDeepDive(mo: RunMetricOutput): React.ReactNode {
    if (mo.float_value == null || !Number.isFinite(mo.float_value)) {
      return null
    }
    const value = mo.float_value

    return (
      <div className="space-y-4 mb-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="text-2xl font-bold">
              {value.toFixed(2)}
              {this.unit} of speech segments above 300Hz
            </span>
          </div>
        </div>
      </div>
    )
  }
}
